import {Component, OnInit} from '@angular/core';
import {TaxReturnsResolver} from "../../tax-returns-resolver";
import {ITaxReturn} from "../model/i-tax-return";
import {Subscription} from "rxjs";
import { ConfigStateService } from '../../../config/config-state.service';
import { TaxReturn } from '../../../../../swaggerServices';
import { cloneDeep } from "lodash-es";

@Component({
    selector: 'app-tax-return-notes',
    templateUrl: './tax-return-notes.component.html',
    styleUrls: ['./tax-return-notes.component.scss'],
    standalone: false
})
export class TaxReturnNotesComponent implements OnInit {
  subscriptions: Subscription[] = [];
  taxReturn: ITaxReturn;
  configLoaded: boolean = false;

  constructor(private taxReturnsResolver: TaxReturnsResolver,
              private config: ConfigStateService
  ) {
  }

  ngOnInit() {
    this.subscriptions.push(this.config.loadConfig().subscribe((config) => {
      this.configLoaded = true;
    }));
    this.subscriptions.push(this.taxReturnsResolver.getTaxReturnObs().subscribe((taxReturn: ITaxReturn) => {
      this.taxReturn = cloneDeep(taxReturn);
    }));
  }

}

